module.exports = __webpack_public_path__ + "static/media/workano-light-logo.59c2ad6f.svg";